module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h-2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "pref"
    }
  }), _vm._v("PREFACE")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("What "), _c('em', [_vm._v("Is")]), _vm._v(" Liberal Christianity?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("W")]), _vm._v("asn't Jesus a liberal?” asked an evangelical Southern Baptist preacher named Gary Vance before the 2004 U.S. election."), _c('a', {
    attrs: {
      "id": "inote-1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" A year later he wrote: “I was saddened by the responses from the Religious Right.” They made “bitter and vitriolic diatribes that questioned my credibility as a minister and my standing in the Kingdom of God.”"), _c('a', {
    attrs: {
      "id": "inote-2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" The values he referred to as “dictionary definitions” of liberalism included belief in progress, tolerance, individual freedom, and the essential goodness of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, I believe that Jesus was a religious liberal. He came with a fresh new progressive vision, proclaiming again and again, “You have heard that it was said to those of ancient times … but I say to you …”"), _c('a', {
    attrs: {
      "id": "inote-3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" Instead of an eye for an eye, he asked us to turn the other cheek."), _c('a', {
    attrs: {
      "id": "inote-4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" Instead of loving just our neighbors, we were called upon to love our enemies too."), _c('a', {
    attrs: {
      "id": "inote-5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" He spoke of a new testament, distinct from the old testament that came before."), _c('a', {
    attrs: {
      "id": "inote-6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" When the apostle Paul described Jesus's new testament, he explained that it was “not of letter but of spirit; for the letter kills, but the spirit gives life.”"), _c('a', {
    attrs: {
      "id": "inote-7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" Jesus was not a fundamentalist in the sense of being a biblical literalist. He would break one of the Ten Commandments when he thought it was the most humane thing to do, as when he worked, healing people, on the Sabbath."), _c('a', {
    attrs: {
      "id": "inote-8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" As he clearly said, “The Sabbath was made for humankind, and not humankind for the Sabbath.”"), _c('a', {
    attrs: {
      "id": "inote-9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I'm a liberal Christian. So are a large number of American Christians, according to sociologists of religion."), _c('a', {
    attrs: {
      "id": "inote-10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" We've also been called “progressive Christians,” and we're generally found in mainline (as distinct from evangelical) churches. Unfortunately, we're often either forgotten or maligned in the current culture wars and public debates between the religious right and the secular left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("We are the religious left. But what do we stand for? Not all of us share exactly the same perspective, of course (nor would we all accept each description in the next paragraph), but we tend to be identifiable by many of the following principles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bible is meant to be read largely metaphorically and allegorically, rather than literally. Science and religion are compatible; we are committed to the use of logic, reason, and the scientific method. Doubt is the handmaiden of faith. Love is the primary Christian value, and it is directly related to the promotion of liberty and justice in society at large. All people are inherently equal and worthy of dignity and respect. Free religious expression should be governmentally protected, but no particular tradition should be established as the state religion. There are many roads to the top of the spiritual mountain, and Christianity is only one of them. Interfaith understanding and tolerance are critical. We see Jesus primarily as a spiritual and ethical teacher and less as being identical with God. Living a fulfilled and ethical life here and now is more important than speculating on what happens to us after we die. Nonviolence is strongly preferred in relationships between human beings, groups, and nations. Women and men must play an equal role in religious leadership. And in terms of current American hot-button issues, we tend to be prochoice on abortion and in favor of marriages for same-sex couples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of us would consider the following people as within the circle of liberal Christianity: theologians Paul Tillich and Hans Kung, civil rights leader Martin Luther King Jr., biblical scholars Marcus Borg and John Dominic Crossan, scholars of religion Diana Eck and Harvey Cox, antiwar activist William Sloane Coffin Jr., authors Annie Dillard and Anne Lamott, Pastor Harry Emerson Fosdick, Sister Joan Chittister, and missionary Albert Schweitzer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We have not always been treated well by conservative Christians, to say the least. This is true well beyond the American context. Historically, some of our forebearers, like Michael Servetus in the sixteenth century, were denounced as heretics and burned at the stake, and others were coerced by the church's Inquisition into renouncing their scientific discoveries, such as Galileo in the seventeenth century. Some, like philosopher John Locke, fared better and had considerable influence on the liberal Christian founders of the United States of America in the eighteenth century, including Thomas Jefferson, Benjamin Franklin, and John and "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Abigail Adams. Yet even liberal Christians of the nineteenth century in America, like Ralph Waldo Emerson and Susan B. Anthony, met with strong public outcries of disgust for their religious beliefs. With the rise of fundamentalism in the twentieth century, liberals were often condemned as “enemies of the cross of Christ” and accused of apostasy."), _c('a', {
    attrs: {
      "id": "inote-11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ironically, however, strong denunciation of liberal Christianity is coming from another quarter in the early twenty-first century: from public atheists in Europe and America—such as scientists Richard Dawkins and Sam Harris, philosopher Daniel Dennett, and journalist Christopher Hitchens—who publish best-selling books with such titles as "), _c('em', [_vm._v("The God Delusion,")]), _c('a', {
    attrs: {
      "id": "inote-12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" "), _c('em', [_vm._v("The End of Faith,")]), _c('a', {
    attrs: {
      "id": "inote-13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" "), _c('em', [_vm._v("Breaking the Spell,")]), _c('a', {
    attrs: {
      "id": "inote-14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" and "), _c('em', [_vm._v("God Is Not Great.")]), _c('a', {
    attrs: {
      "id": "inote-15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today, the estimated 60 million liberal Christians in America"), _c('a', {
    attrs: {
      "id": "inote-16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" are caught in the crossfire between the secular left and the religious right. While outspoken atheists like Richard Dawkins call God a delusion and back up their claim with compelling arguments, well-known conservatives like Ann Coulter, author of "), _c('em', [_vm._v("Godless: The Church of Liberalism,")]), _vm._v(" take aim with damning charges: “Everything liberals believe is in elegant opposition to basic Biblical precepts.”"), _c('a', {
    attrs: {
      "id": "inote-17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" What's a liberal Christian to do?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We liberal Christians know in our hearts that there is much more to life than seems to meet the rational eye of atheists; yet, we find it hard to support supernatural claims about religion that fly in the face of scientific evidence. We also know that there is much more to our personal spirituality than Christian conservatives seem to think there is; yet, we have trouble mustering a response that is convincing to the religious right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The result is that we frequently find ourselves without compelling answers—both for those who challenge our beliefs and even for our own questions about theological and social issues. Many of us choose either to lie low, sitting quietly in our pews at church or in private prayer at home, or to engage in political action without mentioning our faith.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I've written this book for us as liberal Christians—but also for all those interested in learning more about this type of Christianity that so impressed world leaders such as Mohandas Gandhi and Martin Luther King Jr. My goal is to bring new light and life to the perspective of this kind of Christianity and, in doing so, to help liberal Christian readers find their vision and voice, as well as open a dialogue with others. I hope you'll find here fresh, intelligent answers to what a progressive Christian faith is all "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("about and why it is not only relevant but also vitally important in today's world. I also want to provide a meaningful overview of the Christian tradition that demonstrates how Christians can be logical, rational, and scientific within it, as well as metaphoric, poetic, and mythological.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is a result of the many conversations I have had over the past eight years with the congregation at Stanford University's Memorial Church and as a result of my work as the dean for religious life at Stanford. Both the church community and sincere students of many traditions are trying to make sense out of their faith. The doubts, the struggles, and the commitments that are evident in our discussions together have had a profound influence on my own spiritual life, my ministry, and the formulation of many ideas in this book. After my Sunday sermons at Memorial Church a couple of times a month, I have “talk-backs” that attract twenty or thirty people who spend about forty-five minutes discussing the questions that have arisen from what I've said from the pulpit. These talk-backs are intimate and fascinating discussions with agnostics and atheists as well as with assured Christians. They include more older adults than students, and they always affect how I think about future sermons, many of which have inspired what I've written in this book. As dean for religious life, I'm also regularly faced with tough questions from students whose world is being broadened—and whose faith is being challenged—not only by their formal education but also by the never-ending stream of information and diversity of beliefs that we all encounter in today's global environment. I'm very grateful for all of these opportunities for dialogue at Stanford, including with the two associate deans for religious life and members of Stanford Associated Religions groups, who in turn have helped to shape this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn't grow up as a liberal Christian. In my home church in the conservative Midwest, I'd learned to fear hell if I didn't follow the straight and narrow. My Sunday school teachers taught that non-Christians are condemned because they don't accept Jesus uniquely as their Lord and Savior. As a child, I'd found my religion constricting and life-denying. In college, I began to know Jesus in an utterly different way. In my university chapel, I experienced the living Jesus as welcoming, accepting, and joyous. My university chaplain helped me take wing into an open, progressive Christianity. I'd been raised to believe that religion required me to have “blind faith”—that to believe, I must take a “leap of faith” beyond what I knew to be true logically, scientifically, and historically. During "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("my college years, I began to understand that my faith allowed me to integrate "), _c('em', [_vm._v("all")]), _vm._v(" that I knew to be true—rationally and poetically, concretely and mythically. I thankfully realized then that Jesus came so that I might have life in greater abundance than I had ever known. I came to love this “new” Jesus, who was so different from the one I'd been brought up to believe in. He was poet, wisdom teacher, and hope builder, just as surely as he was pragmatist, humanist, and iconoclast. This Jesus—a liberator, not a constrictor or ideologue—has inspired leaders of many generations to work to change the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book intends to speak as powerfully to doubters as to those who sit comfortably in the pews of mainline churches. As a liberal Christian who has made the journey from conservative Christianity through atheism, I'm particularly concerned not only with defending liberal Christianity and supporting liberal Christians in their beliefs, but also with demonstrating how liberal Christianity can provide intelligent responses in increasingly turbulent and extreme times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book should help those of you who are liberal Christians to understand how to approach the Bible, pursue a personal spiritual life, negotiate Christian doctrine, celebrate the Christian year, and participate joyfully in Christian liturgical life—in ways that feed intellectual as well as spiritual needs. The Bible translation that I'll use most often is the New Revised Standard Version (NRSV) of 1989. That's because it stands in a direct line from the King James Version of 1611 but is written in accessible modern English and takes advantage of recent advances in historical, archaeological, and linguistic knowledge; it also uses gender-inclusive language wherever possible."), _c('a', {
    attrs: {
      "id": "inote-18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#note-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Here's some of what I hope to accomplish in these pages:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Demonstrate that liberal Christianity can be a bulwark against religious violence, bigotry, and hatred")]), _vm._v(" "), _c('li', [_vm._v("Provide clear definitions for liberals of terms like faith, God, Jesus, and the church")]), _vm._v(" "), _c('li', [_vm._v("Tackle the hot-button topics of abortion, same-sex marriage, and intelligent design from a liberal Christian perspective")]), _vm._v(" "), _c('li', [_vm._v("Examine social issues such as war, poverty, bigotry, and environmental destruction")]), _vm._v(" "), _c('li', [_vm._v("Reclaim the word “liberal” in its commitment to rationality, tolerance, and dialogue.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("I encourage you as reader to approach the chapters in this book in your own way—sequentially or independently, choosing to read whatever areas pique your interest. I have no intention to proselytize or convert. I hope bridges will be built to conservative Christians as well as to secular humanists. Liberal Christians are tired of being either ignored or condemned by association with our brothers and sisters at one end or the other of the spectrum. In fact, we share many positive values with evangelical Christians as well as with philosophical atheists like those who have written the recent best sellers. I would like to be in dialogue with people of other religious traditions as well. I hope you will come to see how living a liberal Christian life can radically transform and renew a person by redefining what it means to be liberated and playful, inclusive and egalitarian, loving and hopeful, nonviolent and humane, courageous and strong, happy and fulfilled. This book is an invitation to appreciate the joy, freedom, tolerance, and abundance of liberal Christianity.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0b89cfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780230240582_07_preface.vue
// module id = 75
// module chunks = 0